import React, { Component } from 'react';
/*eslint-disable */
import { Route, Switch, Redirect } from 'react-router';
/*eslint-enable */
import { Fragment } from 'react';
import Sammelliste from './components/Collection';
import MainPage from './components/MainPage';
import Uhrencheck from './components/Checkwatch';
import Packliste from './components/Packaging';
import Purchase from './components/Purchase/Purchase';
import QuickPick from './components/QuickPick/QuickPickMain';
import SalesDesk from './components/SalesDesk/SalesDesk';
//import PurchaseDesk from './components/PurchaseDesk/PurchaseDesk'
// import { Link } from 'react-router-dom';

import './App.css'
import Problems from './components/Problems';
import Seller from './components/Seller/Seller';
import { Shipping } from './components/Shipment/Shipping'

//test imported things
import TestNewFeatures from './components/TestNewFeatures'
import ShipmentForm from './components/Shipment/Form/ShipmentForm';
import PurchasePhoneCall from './components/Purchase/PurchasePhoneCall/PurchasePhoneCall';
import PCA_Cockpit_Parent from './components/C24/PCA_Cockpit/PCA_Cockpit_Parent';
import Traders from './components/Traders/Traders';
import Purchasedquery from './components/Purchase/Purchasedquery/Purchasedquery';
import CustomerForm from './components/C24/CustomerForm/CustomerForm';
import WishListForm from './components/C24/WishListPage/WishListForm';
import NestedTable from './components/C24/test/NestedTable'
import SparePart from './components/SpareParts/SpareParts';
import SparePartsIndexedDB from './components/SpareParts/SparePartsIndexedDB';
import SparePartsMain from './components/SpareParts/SparePartsMain';
import UploadShipmentFile from './components/Shipment/UploadShipmentFile';
import ZaView from './components/C24/CustomerForm/ZaView/ZaView';
export default class App extends Component {
  // static displayName = App.name;

  render() {
    return (

      <Fragment>
        {/* REMOVED id="wrapper" FROM THE DIV BELOW, BECAUSE IT HAS AFFECT ON CSS */}
        <div >

          {/* <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">


            <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/">
              <div className="sidebar-brand-icon rotate-n-15">
                <i className="fas fa-laugh-wink"></i>
              </div>
              <div className="sidebar-brand-text mx-3">SB Admin <sup>2</sup></div>
            </Link>


            <hr className="sidebar-divider my-0" />


            <li className="nav-item active">
              <Link className="nav-link" to="/">
                <i className="fas fa-fw fa-tachometer-alt"></i>
                <span>Dashboard</span></Link>
            </li>


            <hr className="sidebar-divider" />


            <div className="sidebar-heading">
              Interface
      </div>


            <li className="nav-item">
              <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                <i className="fas fa-fw fa-cog"></i>
                <span>Components</span>
              </a>
              <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Custom Components:</h6>
                  <a className="collapse-item" href="buttons.html">Buttons</a>
                  <a className="collapse-item" href="cards.html">Cards</a>
                </div>
              </div>
            </li>


            <li className="nav-item">
              <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true" aria-controls="collapseUtilities">
                <i className="fas fa-fw fa-wrench"></i>
                <span>Utilities</span>
              </a>
              <div id="collapseUtilities" className="collapse" aria-labelledby="headingUtilities" data-parent="#accordionSidebar">
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Custom Utilities:</h6>
                  <a className="collapse-item" href="utilities-color.html">Colors</a>
                  <a className="collapse-item" href="utilities-border.html">Borders</a>
                  <a className="collapse-item" href="utilities-animation.html">Animations</a>
                  <a className="collapse-item" href="utilities-other.html">Other</a>
                </div>
              </div>
            </li>


            <hr className="sidebar-divider" />


            <div className="sidebar-heading">
              Addons
      </div>


            <li className="nav-item">
              <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapsePages" aria-expanded="true" aria-controls="collapsePages">
                <i className="fas fa-fw fa-folder"></i>
                <span>Pages</span>
              </a>
              <div id="collapsePages" className="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Login Screens:</h6>
                  <a className="collapse-item" href="login.html">Login</a>
                  <a className="collapse-item" href="register.html">Register</a>
                  <a className="collapse-item" href="forgot-password.html">Forgot Password</a>
                  <div className="collapse-divider"></div>
                  <h6 className="collapse-header">Other Pages:</h6>
                  <a className="collapse-item" href="404.html">404 Page</a>
                  <a className="collapse-item" href="blank.html">Blank Page</a>
                </div>
              </div>
            </li>


            <li className="nav-item">
              <Link className="nav-link" to="/api-table">
                <i className="fas fa-fw fa-chart-area"></i>
                <span>Sammelliste</span></Link>
            </li>


            <li className="nav-item">
              <Link className="nav-link" to="/uhrencheck">
                <i className="fas fa-fw fa-chart-area"></i>
                <span>Uhrencheck</span></Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/Packaging">
                <i className="fas fa-fw fa-chart-area"></i>
                <span>Packliste</span></Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/tables">
                <i className="fas fa-fw fa-table"></i>
                <span>Tables</span></Link>
            </li>


            <hr className="sidebar-divider d-none d-md-block" />


            <div className="text-center d-none d-md-inline">
              <button className="rounded-circle border-0" id="sidebarToggle"></button>
            </div>

          </ul> */}


          <Switch>
            <Route path="/" exact component={MainPage} />

            <Route path="/logistics/collection" render={() => (
              <Sammelliste />
            )} />

            <Route path="/logistics/checkwatch" render={() => (
              <Uhrencheck />
            )} />

            <Route path="/logistics/packaging" render={() => (
              <Packliste />
            )} />
            <Route path="/logistics/problems" render={() => (
              <Problems />
            )} />
            <Route path="/Watches/all-items" render={() => (
              <Purchase />
            )} />
            {/*  <Route exact path="/SafeManagement/quickPick">
              <Redirect to="/SafeManagement?authRedirect=QuickPick" />
            </Route>
            */}
            <Route path="/SafeManagement/quickPick/:token" render={() => (
              <QuickPick />
            )} />
            <Route path="/SafeManagement/quickPick" render={() => (
              <QuickPick />
            )} />
            <Route path="/salesDesk" render={() => (
              <SalesDesk />
            )} />
            <Route path="/Watches/purchase" render={() => (
              <Seller />
            )} />
            <Route path="/testNewFeatures" render={() => (
              <TestNewFeatures />
            )} />

            <Route path="/Shipments/ListView" render={() => (
              <Shipping />
            )} />
            <Route path="/Shipments/ShipFrom" render={() => (
              <ShipmentForm />
            )} />
            <Route path="/Shipments/receiveForm" render={() => (
              <ShipmentForm />
            )} />
            <Route path="/PurchasePhoneCall" render={() => (
              <PurchasePhoneCall />
            )} />
            <Route path="/PCA_Cockpit" render={() => (
              <PCA_Cockpit_Parent />
            )} />
            <Route path="/Traders" render={() => (
              <Traders />
            )} />
            <Route path="/PurchaseMonitoring" render={() => (
              <Purchasedquery />
              //<PCA_Cockpit_Parent />
            )} />
            <Route path="/CustomerForm" render={() => (
              <CustomerForm />
            )} />
            <Route path="/WishList" render={() => (
              <WishListForm />
            )} />
            <Route path="/nestedTable" render={() => (
              <NestedTable />
            )} />
            <Route path="/sparepartstest" render={() => (
              <SparePart />
            )} />
            <Route path="/sparepartsIndexedDB" render={() => (
              <SparePartsIndexedDB />
            )} />
            <Route path="/mainSparePart" render={() => (
              <SparePartsMain />
            )} />
             <Route path="/UploadShipmentFile" render={() => (
              <UploadShipmentFile />
            )} />
            <Route path="/recievedWishes" render={() => (
              <ZaView />
            )} />
          </Switch>

          {/* <MainPage/>
          <TableList/> */}


        </div>



        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>


        {/* <div className="modal fade" id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">Select "Logout" below if you are ready to end your current session.</div>
              <div className="modal-footer">
                <button className="btn btn-secondary" type="button" data-dismiss="modal">Cancel</button>
                <a className="btn btn-primary" href="login.html">Logout</a>
              </div>
            </div>
          </div>
        </div> */}
      </Fragment>
    );
  }
}
